module.exports = __webpack_public_path__ + "img/sec-7_icon-echo.c7e9cefd.svg";